import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import PersonAdd from "@mui/icons-material/PersonAdd";
import PersonRemove from "@mui/icons-material/PersonRemove";
import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";
import {
  AssignDialog,
  useUnassignActivities,
} from "hooks/activities/assignment";
import { compact } from "lodash-es";
import { useState } from "react";
import { useCohortDetails } from "./useCohortDetails";
import { InfoField } from "components/InfoField";

export function CurrentWorkflow() {
  const theme = useTheme();
  const { data } = useCohortDetails();
  const [assignDialogOpen, setAssignDialogOpen] = useState(false);
  const { unassign, loading: unassigning } = useUnassignActivities();

  const cohort = data?.cohort;

  if (!cohort?.currentWorkflow) {
    return null;
  }

  return (
    <Paper
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: 1,
        p: 2,
      }}
      elevation={0}
    >
      <Typography
        variant="h6"
        fontWeight="600"
        sx={{ mb: 1.5, color: theme.palette.text.primary }}
      >
        Current Workflow
      </Typography>

      <Box>
        <InfoField label="Workflow ID" value={cohort.currentWorkflow.id} />
        <InfoField
          label="Workflow Status"
          value={prettyPrintEnumValue(cohort.currentWorkflow.status)}
        />
        <InfoField
          label="Current Activity"
          value={cohort.currentWorkflow.currentActivity?.type ?? "N/A"}
        />
        <InfoField
          label="Current Activity Assignee"
          value={
            cohort.currentWorkflow.currentActivity?.assignee?.email ?? "N/A"
          }
        />
      </Box>

      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        <Button
          disabled={!cohort.currentWorkflow?.currentActivity?.id}
          startIcon={<PersonAdd sx={{ fontSize: 18 }} />}
          onClick={() => setAssignDialogOpen(true)}
          size="small"
        >
          Assign Activity
        </Button>
        <Button
          disabled={
            unassigning || !cohort.currentWorkflow?.currentActivity?.assignee
          }
          startIcon={
            unassigning ? (
              <CircularProgress size={16} />
            ) : (
              <PersonRemove sx={{ fontSize: 18 }} />
            )
          }
          onClick={() =>
            unassign(compact([cohort.currentWorkflow?.currentActivity?.id]))
          }
          size="small"
        >
          Unassign Activity
        </Button>
      </Stack>

      <AssignDialog
        open={assignDialogOpen}
        onClose={() => setAssignDialogOpen(false)}
        activityIds={compact([cohort.currentWorkflow?.currentActivity?.id])}
      />
    </Paper>
  );
}
